import React from 'react';
import { Press } from '../../../components/HOC/HOCDecoratedComponents';

export const PressList = props => {
        const { data, mode, guestMode } = props;
        return (
            <div className="list-achievements">
                { data.map((item) => {
                        item.numberButtons = 3;
                        return (
                            <div key={ item.id } className="item-wrapper">
                                <Press
                                    componentData={ item }
                                    mode={ mode }
                                    actionName="pressApiCall"
                                    guestMode={ guestMode }/>
                            </div>
                        )
                    })
                }
            </div>
        )
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/achievements/PressList.js